import { render, staticRenderFns } from "./AdChange.vue?vue&type=template&id=389fd6d2&"
import script from "./AdChange.vue?vue&type=script&lang=js&"
export * from "./AdChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports